<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="12">
          <h1>Акции</h1>
        </v-col>
      </v-row>
      <v-tabs v-model="tab">
        <v-tab>Список</v-tab>
        <v-tab>Кешбек</v-tab>
        <v-tab>Подарки</v-tab>
        <v-tab>Подарок за первый заказ</v-tab>
        <v-tab>Бесплатная доставка НП</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col class="text-right">
              <v-btn @click="$router.push({ name: 'sale-create'})">Создать</v-btn>
            </v-col>
          </v-row>
          <v-data-table
              no-data-text="Нет акций"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="sales"
              :options.sync="options"
              :fixed-header="true"
              height="70vh"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              :items-per-page="-1"
              loading-text="Загрузка акций... Подождите пожалуйста"
          >
            <template v-slot:item.type="{item, index}">
              {{ item.type === 'all' ? 'Везде' : (item.type === 'local' ? 'Одесса' : 'Новая Почта') }}
            </template>
            <template v-slot:item.actions="{item, index}">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      small
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'sale-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="submitDialog = true; submitItem = item">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item>
          <cashback></cashback>
        </v-tab-item>
        <v-tab-item>
          <gift></gift>
        </v-tab-item>
        <v-tab-item>
          <v-col sm="6">
            <v-autocomplete
                v-model="giftProduct"
                :items="entries"
                :loading="isLoading"
                :search-input.sync="search"
                hide-no-data
                hide-selected
                item-text="name"
                clearable
                item-value="id"
                label="Блюдо Одесса"
                outlined
                return-object
            ></v-autocomplete>
            <v-autocomplete
                v-model="giftUkraineProduct"
                :items="entriesUkraine"
                :loading="isLoadingUkraine"
                :search-input.sync="searchUkraine"
                hide-no-data
                hide-selected
                item-text="name"
                clearable
                item-value="id"
                label="Блюдо Новая Почта"
                outlined
                return-object
            ></v-autocomplete>
            <v-btn @click="updateGiftProduct()"
                   :loading="loading">
              Сохранить
            </v-btn>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-text-field
              v-model="freeDelivery.value"
              label="Беслпатная доставка от"
              outlined
          ></v-text-field>
          <v-btn @click="updateFreeDelivery()"
                 :loading="loading">
            Сохранить
          </v-btn>
        </v-tab-item>
      </v-tabs-items>
      <!--</v-card>-->
    </v-col>
    <v-dialog
        v-model="submitDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
              v-if="submitItem == null"
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              v-else
              @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor" right top>
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
// @ is an alias to /src

import ProductService from './../../api/ProductService'
import SaleService from "../../api/SaleService";
import Cashback from "./Cashback";

import Gift from "./Gift";
import SettingService from "@/api/SettingService";

export default {
  name: 'SalesIndex',
  components: {Gift, Cashback},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: "",
    snackbarColor: "",
    dialog: false,
    freeDelivery: {
      id: null,
      value: null
    },
    search: '',
    entries: [],
    giftProduct: null,
    giftUkraineProduct: null,
    isLoading: false,
    isLoadingUkraine: false,
    entriesUkraine: [],
    searchUkraine: '',
    tab: 0,
    overlay: false,
    loading: true,
    tags: [],
    submitDialog: false,
    submitItem: null,
    options: {},
    footerProps: {
      itemsPerPageText: 'Акций на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        text: 'Акция',
        value: 'name',
      },
      {
        text: 'Дата начала',
        value: 'date_from'
      },
      {
        text: 'Дата окончания',
        value: 'date_to'
      },
      {
        text: 'Время от',
        value: 'time_from',
      },
      {
        text: 'Время до',
        value: 'time_to',
      },
      {
        text: 'Показывать',
        value: 'type',
      },
      {
        value: 'actions',
        sortable: false,
        width: "5%"
      },
    ],
    sales: []
  }),
  mounted() {
    this.getDataFromApi()

  },
  watch: {
    search(val) {
      if (this.isLoading) return

      this.isLoading = true

      ProductService.findByName({word: this.search}).then(response => {
        this.entries = response.data;
      }).finally(response => {
        this.isLoading = false
      });
    },
    searchUkraine(val) {
      if (this.isLoadingUkraine) return

      this.isLoadingUkraine = true

      ProductService.findByName({word: this.searchUkraine}).then(response => {
        this.entriesUkraine = response.data;
      }).finally(response => {
        this.isLoadingUkraine = false
      });
    },
  },
  methods: {
    updateFreeDelivery(){
      SettingService.update(this.freeDelivery.id, {value: this.freeDelivery.value})
    },
    updateGiftProduct() {
      this.loading = true
      SaleService.updateGiftProduct({product_id: this.giftProduct ? this.giftProduct.id : null}).then(response => {
        SaleService.updateUkraineGiftProduct({product_id: this.giftUkraineProduct ? this.giftUkraineProduct.id : null}).then(response => {
          this.loading = false
          this.snackbar = true;
          this.snackbarText = "Сохранено";
          this.snackbarColor = "success";
        })
      })
    },
    submitDelete(item = null) {
      if (item) {
        this.removeSale(item)
      } else {
        // this.massDelete()
      }
    },
    removeSale(item) {
      this.loading = true
      SaleService.remove(item.id).then(response => {
        this.getDataFromApi()
      })
    },
    getDataFromApi() {
      this.loading = true


      SettingService.get('free_delivery_np').then(response => {
        this.freeDelivery = response.data
      });

      SaleService.list()
          .then(response => {
            this.sales = response.data
            this.loading = false
          })

      SaleService.getGiftProduct().then(response => {
        console.log(response.data)
        this.giftProduct = response.data
      })

      SaleService.getUkraineGiftProduct().then(response => {
        console.log(response.data)
        this.giftUkraineProduct = response.data
      })
    },
  }
}
</script>

<style lang="scss">


</style>


<style lang="scss" scoped>

</style>
